<template>
  <div class="device_status_list_right">
    <div>
      设备
    </div>
    <div>状态</div>
    <div class="device-status-list">
      <device-status-item2 v-for="(item,idx) in myDeviceItems" :key="idx" :item="item"></device-status-item2>
    </div>
  </div>
</template>

<script>
  import DeviceStatusItem2 from "@/views/components/DeviceStatus/DeviceStatusItem2";
  import Enumerable from "linq";
  import {DeviceItems2Module }from "@/store/modules/store_deviceitems2"

  export default {
    props:['deviceList'],
    name: "DeviceItems2",
    components: {DeviceStatusItem2},
    computed: {
      myDeviceItems: function () {
        if (this.deviceList&&this.deviceList.length){
          return this.deviceList;
        }
        console.log('myDeviceItems');
        if (this.deviceItems.length) {
          return this.deviceItems;
        }
        let newItems = [];
        for (let i = 0; i < 8; i++) {
          newItems.push({
            name: "设备" + i.toString(),
            title: "设备" + i.toString(),
            status: "false"
          });
        }
        return newItems
      },
      //从DWS中获取相机状态时触发这段方法
      myDeviceModuleitems(){
        return DeviceItems2Module.myDeviceItems2;
      }
    },
    watch:{
      myDeviceModuleitems(newValue) {
        this.deviceItems = newValue;
        console.log("Vuex中存储的相机数据发生变化");
      }
    },
    mounted() {
      var _this = this;
      if (typeof obj_DeviceItems_Core !== "undefined") {
        obj_DeviceItems_Core.registerJavaScriptCallback("DeviceStateRefreshState", function (value) {
          debugger;
          _this.deviceItems = [];
          _this.deviceItems.push(...value);
        });
        obj_DeviceItems_Core.registerJavaScriptCallback("DeviceAddOrUpdateDriver", function (name, status) {
          let c = Enumerable.from(_this.deviceItems);
          let item = c.firstOrDefault(f => f.name === name);
          if (item) {
            item.status = status ? 'true' : 'false';
          }
        });
        obj_DeviceItems_Core.registerJavaScriptCallback("DeviceSetOrUpdateState", function (value) {
          for (let i = 0; i < value.length; i++) {
            let c = Enumerable.from(_this.deviceItems);
            let e = value[i];
            let item = c.firstOrDefault(f => f.name === e.name);
            if (item) {
              item.status = e.status;
              item.title = e.title;
            } else {
              _this.deviceItems.push(e)
            }
          }
        });
        setTimeout(() => {
          this.refreshCameraState()
        }, 2000);
      }
      if (typeof obj_ScanForAcceptPacket !== "undefined") {
        obj_ScanForAcceptPacket.regist_getdevicestate(this.getdevicestatecallback);
      }
      if (typeof obj_ScanForAcceptPacketGetOn !== "undefined") {
        obj_ScanForAcceptPacketGetOn.regist_getdevicestate(this.getdevicestatecallback);
      }

      if (typeof obj_ScanForGetOn !== "undefined") {
        obj_ScanForGetOn.regist_getdevicestate(this.getdevicestatecallback);
      }

      if (typeof obj_ScanForSixScan !== "undefined") {
        obj_ScanForSixScan.regist_getdevicestate(this.getdevicestatecallback);
      }

      if (typeof  obj_ScanForRoughSorting !== "undefined")
      {
        obj_ScanForRoughSorting.regist_getdevicestate(this.getdevicestatecallback);
      }
    },
    data() {
      return {
        deviceStatusItem2 :[],
        items: [],
        deviceItems: []
      }
    },
    methods:{
      refreshCameraState() {
        if (typeof obj_DeviceItems_Core !== "undefined") {
          let json = obj_DeviceItems_Core.getRefreshCameraState();
          this.deviceItems = JSON.parse(json);
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .device_status_list_right {
    text-align: center;
    margin: 0px 0px 0px 10px;
    margin-bottom: 10px;
    height: 100%;
    border: 1px $primaryBorderColor solid;
    background-color: $cardBackColor;
    padding-top: 20px;
  }

  .device-status-list {
    /*position: relative;*/
    /*top: 35%;*/
    /*transform: translateY(-50%);*/
    margin-top: 20px;
  }
</style>
